import Swiper from 'swiper/bundle';
//トップページ　キービジュアルスライダー
export function idxFunc() {
  if ($('#index').length) {
    var heroSwiper, heroOptions, voiceSwiper, voiceOptions;
    heroSwiper = undefined;
    voiceSwiper = undefined;
    heroOptions = {
      direction: 'vertical',
      effect: 'slide',
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 4000,
      },
    };
    voiceOptions = {
      loop: true,
      speed: 1000,
      centeredSlides: true,
      slidesPerView: 1.5,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 3.5,
          spaceBetween: 20
        }
      },
    };
    //スワイプ実行処理
    function initHeroSwiper() {
      heroSwiper = new Swiper('#jsHero', heroOptions);
      voiceSwiper = new Swiper('#jsVoice', voiceOptions);
    }
    initHeroSwiper();

    let scroll,addMaker,makerOffset;
    let makerH,makerTop;
    let makerEle = $('.aniMark');
    
    //文字横スクロール
    var winH = $(window).height();
    var objH = $('#jsMove').outerHeight();
    var objTop = $('#jsMove').offset().top;
    var objBottom = objTop + objH;
    $(window).on('scroll', function () {
      scroll = $(window).scrollTop();
      makerEle.each(function () {
        makerOffset = $(this).offset().top;
        if(scroll >= makerOffset - winH + 100){
          $(this).addClass('marker');
        }
      });
      
      
      if (scroll >= objBottom - winH) {
        $('#jsMove').addClass('start').removeClass('stop');
        
      }
      if(scroll >= objBottom){
        $('#jsMove').addClass('stop');
      }
    });

  }
}